import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import LatestJobs from "./pages/LatestJobs";
import AdmitCards from "./pages/AdmitCards";
import JobDetails from "./pages/JobDetails";
import Layout from "./components/Layout";
import AdminPanel from "./components/AdminPanel";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import AdminDynamicEntry from "./AdminDynamicEntry";
import AdminAdmitCardEntry from "./AdminAdmitCardEntry";
import AdminResultEntry from "./AdminResultEntry";
import UserRegister from "./UserRegister";
import UserLogin from "./UserLogin";
import AdminAdmissionsEntry from "./AdminAdmissionsEntry";
import Results from "./pages/Results";
import AdmissionForms from "./pages/AdmissionForms";
import InfoTemplate from "./components/InfoTemplate";
import InfoPage from "./pages/InfoPage";

//import UserDashboard from "./UserDashboard";

function App() {
  return (
    <Router>
      <Routes>

        {/* ------------------ PUBLIC ROUTES (WITH HEADER) ------------------ */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/latest-jobs" element={<Layout><LatestJobs /></Layout>}/>
        <Route path="/jobdetails/:id" element={<Layout><JobDetails /></Layout>} />
        <Route path="/admit-cards" element={<Layout><AdmitCards /></Layout>} />
        <Route path="/admin-panel" element={<Layout><AdminPanel /></Layout>} />
        <Route path="/results" element={<Layout><Results /></Layout>} />
        <Route path="/admission-forms" element={<Layout><AdmissionForms /></Layout>} />
        <Route path="/InfoTemplate" element={<Layout><InfoTemplate/></Layout> } />
        {/* <Route path="/info/:dataType/:infoId" element={<Layout><InfoPage /></Layout>} /> */}
        <Route path="/info/:dataType/:slug" element={<Layout><InfoPage /></Layout>} />
        {/* ------------------ ADMIN ROUTES (NO HEADER) ------------------ */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        {/* <Route path="/admin-entry" element={<AdminDynamicEntry />} /> */}
        <Route path="/admin/latestjobs/entry" element={<AdminDynamicEntry />} />
        <Route path="/admin/admitcards/entry" element={<AdminAdmitCardEntry />} />
        <Route path="/admit-cards" element={<AdmitCards />} />
        <Route path="/admin/results/entry" element={<AdminResultEntry />} />
        <Route path="/user-register" element={<UserRegister />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/admin/admissions/entry" element={<AdminAdmissionsEntry />} />
        <Route path="/admission-forms" element={<AdmissionForms />} />
        <Route path="/results" element={<Results />} />
        
        {/* ------------------ 404 PAGE ------------------ */}
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />

      </Routes>
    </Router>
  );
}

export default App;

